import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {CustomComponent, Link} from '../../common/components';
import {SearchBar} from './SearchBar';
import {document, window, isMobile} from '../../common/util';

import './TopSearchBar.scss';


export class TopBar extends CustomComponent {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        let fixedTop = false;
        if (document.documentElement || document.body) {
            const scrollTop = window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop || 0;
            if (scrollTop > 50) {
                fixedTop = true;
            }
        }
        this.state = {
            ...this.state,
            fixedTop,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.setFixedTop);
        window.addEventListener('scroll', this.setFixedTop);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setFixedTop);
        window.removeEventListener('scroll', this.setFixedTop);
    }

    @autobind
    setFixedTop() {
        if (isMobile() && this.props.preventMobileSticky) {
            this.setState({fixedTop: false});
            return;
        }
        if (document.documentElement || document.body) {
            const scrollTop = window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop || 0;
            if (!this.state.fixedTop && scrollTop > 50) {
                this.setState({fixedTop: true});
            }
            if (this.state.fixedTop && scrollTop <= 50) {
                this.setState({fixedTop: false});
            }
        }
    }

    render() {
        const {fixedTop} = this.state;
        const {className} = this.props;
        return (
            <div className={`TopBarComponent${className ? ` ${className}` : ''}`}>
                <div className={`TopBar${fixedTop ? ' fixed-top' : ''}`}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export class TopSearchBar extends CustomComponent {
    render() {
        const gettextSub = this.context.gtService.gettextSub;
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        return (
            <TopBar className="TopSearchBar">
                <div className="container">
                    <Link to={localizeUrlPath('/')} className="navbar-brand" itemProp="url">
                        {/*
                            This logo appears as the user scrolls down the page.
                        */}
                        <img
                            src="/assets/img/tenor-logo-white.svg"
                            width="80"
                            height="22"
                            alt={gettextSub('Tenor logo')}
                            itemProp="logo"
                        />
                    </Link>
                    <div className="search-bar-wrapper"><SearchBar/></div>
                </div>
            </TopBar>
        );
    }
}
